// reviews slider
(function () {
    var reviews = document.querySelector('.reviews');
    var slider = reviews && reviews.querySelector('.reviews__slider');

    if (slider) {
        new Swiper(slider, {
            spaceBetween: 21,
            slidesPerView: 'auto',
            watchOverflow: true,
            navigation: {
                nextEl: reviews.querySelector('.carousel-nav__arrow--next'),
                prevEl: reviews.querySelector('.carousel-nav__arrow--prev'),
            },
            pagination: {
                el: reviews.querySelector('.reviews__pagination'),
                clickable: true,
            },
            breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 21,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 21,
              }
            }
        });
    }
})();
